module.exports = __webpack_public_path__ + "static/media/step5.628a4ec3.png";